import React from 'react';
import { campaignProjectNumber } from './useCampaignResultsAvailability';

export function campaignResultsColumn(availability) {
    return {
        title: 'Campaign results',
        key: 'campaignResults',
        sortDirections: ['descend', 'ascend'],
        align: 'center',
        width: 110,
        render: (_, record) => availability[campaignProjectNumber(record)] === true
            ? <a href={`/project-management/project/${encodeURIComponent(record.project_id || campaignProjectNumber(record))}?tab=campaign-results`} style={{ textDecoration: 'underline', color: '#167b39', fontWeight: 600 }}>Available</a>
            : null,
    };
}
